import { render, staticRenderFns } from "./bindStates.vue?vue&type=template&id=b1085058&scoped=true&"
import script from "./bindStates.vue?vue&type=script&lang=js&"
export * from "./bindStates.vue?vue&type=script&lang=js&"
import style0 from "./bindStates.vue?vue&type=style&index=0&id=b1085058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1085058",
  null
  
)

export default component.exports